<template>
    <div class="content-wrapper">
        <PageHeader :screenName="'Editar '+tituloNome" :linkItems="linkItems"/>

        <ConfirmModal
            itemIdentifier="usuário"
            :modalShow="modal.showModal"
            :typeModal="modal.typeModal"
            @confirmed="redirecionarLista"
            @canceled="closeModalConfirm"
        />

        <SucessoModal
            :modalShow="modalSucesso.showModal"
            :typeModal="modalSucesso.typeModal"
            :caseModal="modalSucesso.caseModal"
            @confirmed="redirecionarLista"
        />

        <ErrorModal
            :modalShow="modalError.showModal"
            :typeModal="modalError.typeModal"
            :caseModal="modalError.caseModal"
            @confirmed="redirecionarLista"
        />

        <ModalConfirmacaoImpactoAlteracao
            :modalShow="modalConfirmacaoAlteracao.showModal"
            @confirmed="salvaVacina(true)"
            @canceled="closeModalConfirmacaoAlteracao"
        />

        <main class="card p-2">
            <section class="form">
                <validation-observer ref="vacinaRules">
                    <b-form>
                        <b-row>
                            <b-col lg="6" md="6" sm="12">
                                <b-form-group label="Nome técnico da vacina*"
                                label-for="nome-tecnico-vacina-input"
                                label-class="label_size_vacina">
                                    <validation-provider
                                        #default="{ errors }"
                                        name="NomeTecnicoVacina"
                                        rules="required"
                                    >
                                        <b-form-input
                                            :state="errors.length > 0 || form.errorApi.nomeTecnico || form.errorApi.error ? false:null"
                                            id="nome-tecnico-vacina-input"
                                            v-model="form.nomeTecnico"
                                            placeholder="Ex: Varicela"
                                            v-mask="('X'.repeat(250))"
                                        />
                                        <small class="text-muted">
                                            Nome conhecido no meio científico.
                                        </small>
                                        <br>
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errorApi.nomeTecnico" class="text-danger">
                                            {{ form.errorApi.nomeTecnico }}
                                        </small>
                                        <small v-if="form.errorApi.error" class="text-danger">
                                            {{ form.errorApi.error }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="6" md="6" sm="12">
                                <SelectDoencas
                                    @GetDoenca="setDoenca"
                                    :values="doencasSelecionadas"
                                    :errorApi="form.errorApi.doencasSelecionadas"
                                />
                            </b-col>
                            <b-col lg="3" md="6" sm="12">
                                <b-form-group label="Nome popular da vacina"
                                label-for="nome-popular-vacina-input"
                                label-class="label_size_vacina">
                                    <validation-provider
                                        #default="{ errors }"
                                        name="NomePopularVacina"
                                    >
                                        <b-form-input
                                            :state="errors.length > 0 || form.errorApi.nomePopular ? false:null"
                                            id="nome-popular-vacina-input"
                                            v-model="form.nomePopular"
                                            placeholder="Ex: Catapora"
                                            v-mask="('X'.repeat(250))"
                                        />
                                        <small class="text-muted">
                                            Nome conhecido popularmente.
                                        </small>
                                        <br>
                                        <small v-if="form.errorApi.nomePopular" class="text-danger">
                                            {{ form.errorApi.nomePopular }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col lg="3" md="3" sm="12">
                              <b-form-group
                                  label="Tipo Vacina*"
                                  label-for="tipo-vacina-input"
                                  label-class="label_size_vacina"
                              >
                                <validation-provider
                                    #default="{ errors }"
                                    name="Tipo Vacina"
                                    rules="required"
                                >
                                  <v-select
                                      id="tipo-vacina-input"
                                      :options="tipoVacinaOptions"
                                      v-model="form.tipoVacina"
                                      placeholder="Tipo Vacina"
                                      label="descricao"
                                      :clearable="true"
                                      item-text="Tipo Vacina"
                                      item-value="Tipo Vacina"
                                  >
                                    <span slot="no-options">Nenhuma opção selecionável.</span>
                                  </v-select>
                                  <small v-if="errors[0]" class="text-danger">
                                    {{errors[0]}}
                                  </small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>

                            <b-col lg="3" md="3" sm="12">
                              <validation-provider #default="{ errors }" name="Código RNDS">
                                <b-form-group
                                    label-class="label_size_vacina"
                                    v-mask="'#####'"
                                    :state="
                                      errors.length > 0 ||
                                      form.errorApi.idTipoAplicacaoSelecionado
                                          ? false
                                          : null
                                      "
                                >
                                <label
                                    class="d-flex align-items-center label_size_vacina"
                                    for="codigo-rnds-input"
                                    >
                                    Código RNDS
                                    <feather-icon
                                    v-b-tooltip.hover.top="{variant: 'dark'}"
                                    title="Para registro do imunobiológico administrado, deverão ser utilizados os códigos disponibilizados no CodeSystem “BRImunobiologico” da RNDS"
                                    icon="AlertCircleIcon" class="ml-50" />
                                </label>
                                  <b-form-input
                                      :state="
                                          errors.length > 0 || form.errorApi.codeRndsVaccine
                                          ? false
                                          : null
                                      "
                                      id="codigo-rnds-input"
                                      v-model="form.codeRndsVaccine"
                                      placeholder="Código RNDS"
                                  />
                                  <small v-if="form.errorApi.codeRndsVaccine" class="text-danger">
                                    {{ form.errorApi.codeRndsVaccine }}
                                  </small>
                                </b-form-group>
                              </validation-provider>
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <validation-provider #default="{ errors }" name="código para integração externa" rules="max:7">
                                <b-form-group
                                    label="Código para integração externa"
                                    label-for="code-external-input"
                                    label-class="label_size_vacina"
                                    :state="
                                    errors.length > 0 ||
                                    form.errorApi.idTipoAplicacaoSelecionado
                                        ? false
                                        : null
                                    "
                                >
                                    <b-form-input
                                    :state="
                                        errors.length > 0 || form.errorApi.codeExternalIntegration
                                        ? false
                                        : null
                                    "
                                    id="code-external-input"
                                    v-model="form.codeExternalIntegration"
                                    placeholder="Código para integração externa"
                                    />
                                    <small v-if="form.errorApi.codeExternalIntegration" class="text-danger">
                                    {{ form.errorApi.codeExternalIntegration }}
                                    </small>
                                </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col lg="5" md="12" sm="12">
                                <validation-provider
                                    #default="{ errors }"
                                    name="TipoAplicaçãoVacina"
                                    rules="required"
                                >
                                    <b-form-group
                                    label="Tipo de aplicação*"
                                    label-for="id-tipo-aplicacao-selecionado-input"
                                    label-class="label_size_vacina"
                                    :state="errors.length > 0 || form.errorApi.idTipoAplicacaoSelecionado ? false:null">
                                        <v-select
                                            id="id-tipo-aplicacao-selecionado-input"
                                            v-model="form.idTipoAplicacaoSelecionado"
                                            :options="tiposAplicacaoSelect"
                                            label="descricao"
                                            multiple
                                            placeholder="Selecione o tipo de aplicação"
                                            :clearable="false"
                                            :reduce="(option => option.id_tipo_aplicacao)"
                                        >
                                            <template #selected-option="item">
                                                <span> {{ item.codigo_via_administracao }} - {{ item.descricao }}</span>
                                            </template>
                                            <template #option="item">
                                                <span> {{ item.codigo_via_administracao }} - {{ item.descricao }}</span>
                                            </template>
                                            <span slot="no-options">Nenhuma opção selecionável.</span>
                                        </v-select>
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errorApi.idTipoAplicacaoSelecionado" class="text-danger">
                                            {{ form.errorApi.idTipoAplicacaoSelecionado }}
                                        </small>
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col lg="5" md="12" sm="12">
                              <validation-provider
                                  #default="{ errors }"
                                  name="LocalAplicaçãoVacina"
                                  rules="required"
                              >
                                <b-form-group
                                    label="Local de aplicação*"
                                    label-for="id-local-aplicacao-selecionado-input"
                                    label-class="label_size_vacina"
                                    :state="errors.length > 0 || form.errorApi.idLocalAplicacaoSelecionado ? false:null">
                                  <v-select
                                      id="id-local-aplicacao-selecionado-input"
                                      v-model="form.idLocalAplicacaoSelecionado"
                                      multiple
                                      :options="locaisAplicacaoSelect"
                                      label="descricao"
                                      placeholder="Região anatômica"
                                      :clearable="false"
                                      :reduce="(option => option.id_local_aplicacao)"
                                  >
                                    <template #selected-option="item">
                                        <span> {{ item.codigo_local_aplicacao }} - {{ item.descricao }}</span>
                                    </template>
                                    <template #option="item">
                                        <span> {{ item.codigo_local_aplicacao }} - {{ item.descricao }}</span>
                                    </template>
                                    <span slot="no-options">Nenhuma opção selecionável.</span>
                                  </v-select>
                                  <small class="text-muted">
                                    Localização anatômica onde a vacina será aplicada.
                                  </small>
                                  <br />
                                  <small v-if="errors[0]" class="text-danger">
                                    Este campo é de preenchimento obrigatório.
                                  </small>
                                  <small v-if="form.errorApi.idLocalAplicacaoSelecionado" class="text-danger">
                                    {{ form.errorApi.idLocalAplicacaoSelecionado }}
                                  </small>
                                </b-form-group>
                              </validation-provider>
                            </b-col>

                            <b-col lg="12" md="12" sm="12">
                              <h3 class="mb-1">Parametrização / SMD</h3>
                            </b-col>

                            <b-col lg="3" md="6" sm="12">
                              <validation-provider #default="{ errors }" name="Código do Produto" rules="required|max:7">
                                <b-form-group
                                    label="Código do Produto*"
                                    label-for="codigo-produto-input"
                                    label-class="label_size_vacina"
                                    :state=" errors.length > 0 || form.errorApi.idTipoAplicacaoSelecionado ? false : null"
                                >
                                  <b-form-input
                                      :state=" errors.length > 0 || form.errorApi.productCode ? false : null"
                                      id="codigo-produto-input"
                                      v-model="form.productCode"
                                      placeholder="Código do Produto"
                                  />
                                  <small v-if="form.errorApi.productCode" class="text-danger">
                                    {{ form.errorApi.productCode }}
                                  </small>
                                  <div v-if="errors && errors.length" class="text-danger">
                                    <small v-for="(error, index) in errors" :key="index" class="text-danger d-block">
                                      {{ error }}
                                    </small>
                                  </div>
                                </b-form-group>
                              </validation-provider>
                            </b-col>

                            <b-col lg="3" md="6" sm="12">
                              <validation-provider #default="{ errors }" name="Código do Formulário" rules="required|max:7">
                                <b-form-group
                                    label="Código do Formulário*"
                                    label-for="codigo-formulario-external-input"
                                    label-class="label_size_vacina"
                                    :state=" errors.length > 0 || form.errorApi.idTipoAplicacaoSelecionado ? false : null"
                                >
                                  <b-form-input
                                      :state=" errors.length > 0 || form.errorApi.codigoFormulario ? false : null"
                                      id="codigo-formulario-external-input"
                                      v-model="form.codigoFormulario"
                                      placeholder="Código do Formulário"
                                  />
                                  <small v-if="form.errorApi.codigoFormulario" class="text-danger">
                                    {{ form.errorApi.codigoFormulario }}
                                  </small>
                                  <div v-if="errors && errors.length" class="text-danger">
                                    <small v-for="(error, index) in errors" :key="index" class="text-danger d-block">
                                      {{ error }}
                                    </small>
                                  </div>
                                </b-form-group>
                              </validation-provider>
                            </b-col>

                            <b-col lg="3" md="6" sm="12">
                              <validation-provider #default="{ errors }" name="Código do Projeto" rules="required|max:7">
                                <b-form-group
                                    label="Código do Projeto*"
                                    label-for="codigo-projeto-external-input"
                                    label-class="label_size_vacina"
                                    :state=" errors.length > 0 || form.errorApi.idTipoAplicacaoSelecionado ? false : null"
                                >
                                  <b-form-input
                                      :state=" errors.length > 0 || form.errorApi.codigoProjeto ? false : null"
                                      id="codigo-projeto-external-input"
                                      v-model="form.codigoProjeto"
                                      placeholder="Código do Projeto"
                                  />
                                  <small v-if="form.errorApi.codigoProjeto" class="text-danger">
                                    {{ form.errorApi.codigoProjeto }}
                                  </small>
                                  <div v-if="errors && errors.length" class="text-danger">
                                    <small v-for="(error, index) in errors" :key="index" class="text-danger d-block">
                                      {{ error }}
                                    </small>
                                  </div>
                                </b-form-group>
                              </validation-provider>
                            </b-col>

                            <b-col lg="3" md="6" sm="12">
                              <validation-provider #default="{ errors }" name="Código da Série" rules="required|max:7">
                                <b-form-group
                                    label="Código da Série*"
                                    label-for="codigo-serie-external-input"
                                    label-class="label_size_vacina"
                                    :state=" errors.length > 0 || form.errorApi.idTipoAplicacaoSelecionado ? false : null"
                                >
                                  <b-form-input
                                      :state=" errors.length > 0 || form.errorApi.codigoSerie ? false : null"
                                      id="codigo-serie-external-input"
                                      v-model="form.codigoSerie"
                                      placeholder="Código da Série"
                                  />
                                  <small v-if="form.errorApi.codigoSerie" class="text-danger">
                                    {{ form.errorApi.codigoSerie }}
                                  </small>
                                  <div v-if="errors && errors.length" class="text-danger">
                                    <small v-for="(error, index) in errors" :key="index" class="text-danger d-block">
                                      {{ error }}
                                    </small>
                                  </div>
                                </b-form-group>
                              </validation-provider>
                            </b-col>

                            <b-col lg="3" md="6" sm="12">

                              <validation-provider #default="{ errors }" name="Centro de Responsabilidade" rules="required|max:9">
                                <b-form-group
                                    label="Centro de Responsabilidade*"
                                    label-for="centro-responsabilidade-external-input"
                                    label-class="label_size_vacina"
                                    :state=" errors.length > 0 || form.errorApi.idTipoAplicacaoSelecionado ? false : null"
                                >
                                  <b-form-input
                                      :state=" errors.length > 0 || form.errorApi.centroResponsabilidade ? false : null"
                                      id="centro-responsabilidade-external-input"
                                      v-model="form.centroResponsabilidade"
                                      placeholder="Centro de Responsabilidade"
                                  />
                                  <small v-if="form.errorApi.centroResponsabilidade" class="text-danger">
                                    {{ form.errorApi.centroResponsabilidade }}
                                  </small>
                                  <div v-if="errors && errors.length" class="text-danger">
                                    <small v-for="(error, index) in errors" :key="index" class="text-danger d-block">
                                      {{ error }}
                                    </small>
                                  </div>
                                </b-form-group>
                              </validation-provider>
                            </b-col>

                            <b-col lg="3" md="6" sm="12">

                              <validation-provider #default="{ errors }" name="Código da Modalidade" rules="required|max:7">
                                <b-form-group
                                    label="Código da Modalidade*"
                                    label-for="codigo-modalidade-external-input"
                                    label-class="label_size_vacina"
                                    :state=" errors.length > 0 || form.errorApi.idTipoAplicacaoSelecionado ? false : null"
                                >
                                  <b-form-input
                                      :state=" errors.length > 0 || form.errorApi.codigoModalidade ? false : null"
                                      id="codigo-modalidade-external-input"
                                      v-model="form.codigoModalidade"
                                      placeholder="Código da Modalidade"
                                  />
                                  <small v-if="form.errorApi.codigoModalidade" class="text-danger">
                                    {{ form.errorApi.codigoModalidade }}
                                  </small>
                                  <div v-if="errors && errors.length" class="text-danger">
                                    <small v-for="(error, index) in errors" :key="index" class="text-danger d-block">
                                      {{ error }}
                                    </small>
                                  </div>
                                </b-form-group>
                              </validation-provider>
                            </b-col>

                            <b-col lg="3" md="6" sm="12">
                              <validation-provider #default="{ errors }" name="Código da Carga Horária" rules="required|max:7">
                                <b-form-group
                                    label="Código da Carga Horária*"
                                    label-for="codigo-carga-horaria-external-input"
                                    label-class="label_size_vacina"
                                    :state=" errors.length > 0 || form.errorApi.idTipoAplicacaoSelecionado ? false : null"
                                >
                                  <b-form-input
                                      :state=" errors.length > 0 || form.errorApi.codigoCargaHoraria ? false : null"
                                      id="codigo-carga-horaria-external-input"
                                      v-model="form.codigoCargaHoraria"
                                      placeholder="Código da Carga Horária"
                                  />
                                  <small v-if="form.errorApi.codigoCargaHoraria" class="text-danger">
                                    {{ form.errorApi.codigoCargaHoraria }}
                                  </small>
                                  <div v-if="errors && errors.length" class="text-danger">
                                    <small v-for="(error, index) in errors" :key="index" class="text-danger d-block">
                                      {{ error }}
                                    </small>
                                  </div>
                                </b-form-group>
                              </validation-provider>
                            </b-col>

                            <b-col lg="3" md="6" sm="12">


                              <validation-provider #default="{ errors }" name="Código da Competência" rules="required|max:7">
                                <b-form-group
                                    label="Código da Competência*"
                                    label-for="codigo-competencia-external-input"
                                    label-class="label_size_vacina"
                                    :state=" errors.length > 0 || form.errorApi.idTipoAplicacaoSelecionado ? false : null"
                                >
                                  <b-form-input
                                      :state=" errors.length > 0 || form.errorApi.codigoCompetencia ? false : null"
                                      id="codigo-competencia-external-input"
                                      v-model="form.codigoCompetencia"
                                      placeholder="Código da Competência"
                                  />
                                  <small v-if="form.errorApi.codigoCompetencia" class="text-danger">
                                    {{ form.errorApi.codigoCompetencia }}
                                  </small>
                                  <div v-if="errors && errors.length" class="text-danger">
                                    <small v-for="(error, index) in errors" :key="index" class="text-danger d-block">
                                      {{ error }}
                                    </small>
                                  </div>
                                </b-form-group>
                              </validation-provider>
                            </b-col>

                            <b-col lg="3" md="6" sm="12">

                              <validation-provider #default="{ errors }" name="Código do Financiamento"
                                                   rules="required|max:7">
                                <b-form-group
                                    label="Código do Financiamento*"
                                    label-for="codigo-financiamento-external-input"
                                    label-class="label_size_vacina"
                                    :state=" errors.length > 0 || form.errorApi.idTipoAplicacaoSelecionado ? false : null"
                                >
                                  <b-form-input
                                      :state=" errors.length > 0 || form.errorApi.codigoFinanciamento ? false : null"
                                      id="codigo-financiamento-external-input"
                                      v-model="form.codigoFinanciamento"
                                      placeholder="Código do Financiamento"
                                  />
                                  <small v-if="form.errorApi.codigoFinanciamento" class="text-danger">
                                    {{ form.errorApi.codigoFinanciamento }}
                                  </small>
                                  <div v-if="errors && errors.length" class="text-danger">
                                    <small v-for="(error, index) in errors" :key="index" class="text-danger d-block">
                                      {{ error }}
                                    </small>
                                  </div>
                                </b-form-group>
                              </validation-provider>
                            </b-col>

                            <b-col lg="3" md="6" sm="12">
                              <validation-provider #default="{ errors }" name="Código da Unidade de Controle"
                                                   rules="required|max:7">
                                <b-form-group
                                    label="Código da Unidade de Controle*"
                                    label-for="codigo-unidade-controle-external-input"
                                    label-class="label_size_vacina"
                                    :state=" errors.length > 0 || form.errorApi.idTipoAplicacaoSelecionado ? false : null"
                                >
                                  <b-form-input
                                      :state=" errors.length > 0 || form.errorApi.codigoUnidadeControle ? false : null"
                                      id="codigo-unidade-controle-external-input"
                                      v-model="form.codigoUnidadeControle"
                                      placeholder="Código da Unidade de Controle"
                                  />
                                  <small v-if="form.errorApi.codigoUnidadeControle" class="text-danger">
                                    {{ form.errorApi.codigoUnidadeControle }}
                                  </small>
                                  <div v-if="errors && errors.length" class="text-danger">
                                    <small v-for="(error, index) in errors" :key="index" class="text-danger d-block">
                                      {{ error }}
                                    </small>
                                  </div>
                                </b-form-group>
                              </validation-provider>
                            </b-col>

                            <DoseConfiguration
                                v-model="form.dose"
                                :edit="true"
                                :errorApi="form.errorApi.dose"
                                @doseConfiguration="form.dose.list = $event"
                                @typeDose="form.dose.type = $event"
                                @interval="form.dose.interval = $event"
                                @intervalDateOption="form.dose.intervalDateOption = $event"
                                class="mb-2"
                            />

                            <b-col lg="12" md="12" sm="12">
                                <b-form-group label="Descrição*"
                                label-for="descricao-vacina-input"
                                label-class="label_size_vacina">
                                    <validation-provider
                                        #default="{ errors }"
                                        name="DescricaoVacina"
                                        rules="required"
                                    >
                                        <b-form-textarea
                                            :state="errors.length > 0 || form.errorApi.descricao ? false:null"
                                            id="descricao-vacina-input"
                                            rows="5"
                                            placeholder="Adicione uma descrição para esta vacina"
                                            v-model="form.descricao"
                                            no-resize
                                        />
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errorApi.descricao" class="text-danger">
                                            {{ form.errorApi.descricao }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="12" md="12" sm="12">
                                <b-form-group label="Contraindicações*"
                                label-for="contraindicacao-vacina-input"
                                label-class="label_size_vacina">
                                    <validation-provider
                                        #default="{ errors }"
                                        name="ContraindicacaoVacina"
                                        rules="required"
                                    >
                                        <b-form-textarea
                                            :state="errors.length > 0 || form.errorApi.contraindicacao ? false:null"
                                            id="contraindicacao-vacina-input"
                                            rows="5"
                                            placeholder="Adicione contraindicações para esta vacina"
                                            v-model="form.contraindicacao"
                                            no-resize
                                        />
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errorApi.contraindicacao" class="text-danger">
                                            {{ form.errorApi.contraindicacao }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="12" md="12" sm="12">
                                <b-form-group label="Possíveis eventos adversos*"
                                label-for="efeito-colateral-vacina-input"
                                label-class="label_size_vacina">
                                    <validation-provider
                                        #default="{ errors }"
                                        name="EfeitoColateralVacina"
                                        rules="required"
                                    >
                                        <b-form-textarea
                                            :state="errors.length > 0 || form.errorApi.efeitoColateral ? false:null"
                                            id="efeito-colateral-vacina-input"
                                            rows="5"
                                            placeholder="Adicione possíveis eventos adversos para esta vacina"
                                            v-model="form.efeitoColateral"
                                            no-resize
                                        />
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errorApi.efeitoColateral" class="text-danger">
                                            {{ form.errorApi.efeitoColateral }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="12" md="12" sm="12">
                                <b-form-group label="Cuidados antes, durante e após a vacinação*"
                                label-for="cuidados-vacina-input"
                                label-class="label_size_vacina">
                                    <validation-provider
                                        #default="{ errors }"
                                        name="CuidadosVacina"
                                        rules="required"
                                    >
                                        <b-form-textarea
                                            :state="errors.length > 0 || form.errorApi.cuidados ? false:null"
                                            id="cuidados-vacina-input"
                                            rows="5"
                                            placeholder="Adicione cuidados para esta vacina"
                                            v-model="form.cuidados"
                                            no-resize
                                        />
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errorApi.cuidados" class="text-danger">
                                            {{ form.errorApi.cuidados }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </validation-observer>
            </section>
            <section class="buttons">
                <b-button id="save-vacina"
                    class="mr-2 mt-3 botao_responsivo"
                    variant="custom-blue"
                    @click.prevent="validationForm(true)"
                    :disabled="saving"
                >
                    <feather-icon icon="CheckIcon" class="mr-50"/>
                    <span class="align-middle">Salvar vacina</span>
                    <span v-if="saving" class="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>
                </b-button>
                <b-button id="cancel-register-vacina"
                    :disabled="saving"
                    variant="outline-danger"
                    @click.prevent="openModalConfirm"
                    class="mt-3"
                >
                    <feather-icon icon="XIcon" class="mr-50"/>
                    <span class="align-middle">Cancelar</span>
                </b-button>
            </section>
        </main>
    </div>
</template>

<script>
import { BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadio, BButton, BFormTextarea } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue'
import ConfirmModal from '@/views/components/custom/modals/ConfirmModal.vue'
import SelectDoencas from '@/views/custom-pages/vacina/Select-doencas.vue'
import SucessoModal from '@/views/components/custom/modals/SucessoCriacaoEdicaoModal.vue'
import ErrorModal from '@/views/components/custom/modals/ErroIdInexistenteModal.vue'
import handleErrorsService from './Services/HandleErrors'
import { getIdVacina, getVacinaConfirmada } from '@core/utils/store/getStore';
import { setIdVacina, setVacinaComEdicaoConfirmada } from '@core/utils/store/setStore';
import DoseConfiguration from './Components/DoseConfiguration.vue'
import ModalConfirmacaoImpactoAlteracao from "@/views/components/custom/modals/vacina/ModalConfirmacaoImpactoAlteracao.vue";

export default {
    title: 'Editar vacina',

    components: {
        ModalConfirmacaoImpactoAlteracao,
        BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadio, BFormTextarea,
        BButton, vSelect, ValidationProvider, ValidationObserver,
        PageHeader, ConfirmModal, SelectDoencas, SucessoModal, ErrorModal,
        DoseConfiguration
    },

    data() {
        return {
            linkItems: [
                {
                    name: 'Vacinas',
                    routeName: 'vacina-list'
                },
                {
                    name: 'Editar',
                    active: true
                }
            ],
            modal: {
                showModal: false,
                typeModal: 'danger'
            },
            modalSucesso: {
                showModal: false,
                typeModal: 'success',
                caseModal: 'edicao'
            },
            modalError: {
                showModal: false,
                typeModal: 'error',
                caseModal: 'idInexistente'
            },
            modalConfirmacaoAlteracao: {
              showModal: false,
            },
            required,
            saving: false,
            form: {
                nomeTecnico: '',
                nomePopular: '',
                descricao: '',
                productCode: '',
                codeExternalIntegration: '',
                contraindicacao: '',
                efeitoColateral: '',
                cuidados: '',
                idTipoAplicacaoSelecionado: null,
                codeRndsVaccine:null,
                idLocalAplicacaoSelecionado: null,
                tipoVacina: null,
                codigoFormulario: "",
                codigoProjeto: "",
                codigoSerie: "",
                centroResponsabilidade: "",
                codigoModalidade: "",
                codigoCargaHoraria: "",
                codigoCompetencia: "",
                codigoFinanciamento: "",
                codigoUnidadeControle: "",
                existeRegistroVacinacao: false,
                dose: {
                    list: [],
                    type: null,
                    interval: null,
                    intervalDateOption: {
                        value: 'dias',
                        text: 'Dia(s)'
                    }
                },
                errorApi: {
                    nomeTecnico: '',
                    nomePopular: '',
                    descricao: '',
                    contraindicacao: '',
                    efeitoColateral: '',
                    productCode:'',
                    codeRndsVaccine:'',
                    codeExternalIntegration: '',
                    cuidados: '',
                    idTipoAplicacaoSelecionado: '',
                    idLocalAplicacaoSelecionado: '',
                    doencasSelecionadas: '',
                    tipoVacina: null,
                    codigoFormulario: "",
                    codigoProjeto: "",
                    codigoSerie: "",
                    centroResponsabilidade: "",
                    codigoModalidade: "",
                    codigoCargaHoraria: "",
                    codigoCompetencia: "",
                    codigoFinanciamento: "",
                    codigoUnidadeControle: "",
                    dose: {
                        list: "",
                        type: "",
                        interval: "",
                    },
                    error: ''
                }
            },
            doencasSelecionadas: [],
            tiposAplicacaoSelect: [],
            locaisAplicacaoSelect: [],
            idVacinaEditar : null,
            tituloNome: '',
            tipoVacinaOptions: [],
        }
    },

    async mounted(){
        if((getIdVacina() === null || typeof getIdVacina() == 'undefined') && typeof this.$route.params.idVacina == "undefined") {
            return this.openModalError();
        }else if(typeof this.$route.params.idVacina != "undefined" && this.$route.params.idVacina !== getIdVacina()) {
            setIdVacina(this.$route.params.idVacina);
        }

        this.$http.get(this.$api.vaccineParameter(getIdVacina())).then(({ data }) => {
            this.preenchimentoFormulario(data);
        });
    },

    methods: {

        validationForm(redirectToList) {
            this.$refs.vacinaRules.validate().then(success => {
                if (!success) return;

                const id = getIdVacina();

                if (this.form.existeRegistroVacinacao && !getVacinaConfirmada(id)) {
                    this.modalConfirmacaoAlteracao.showModal = true;
                } else {
                    this.editVacina(redirectToList);
                }

                if (redirectToList) {
                    this.saving = true;
                }
            })
        },

        salvaVacina(redirectToList) {
            const id = getIdVacina();
            setVacinaComEdicaoConfirmada(id);

            this.editVacina(redirectToList);
        },

        editVacina(redirectToList) {

            const parameters = {
                'nome_tecnico': this.form.nomeTecnico,
                'nome_popular': this.form.nomePopular,
                'descricao': this.form.descricao,
                'contraindicacao': this.form.contraindicacao,
                'efeito_colateral': this.form.efeitoColateral,
                'cuidados': this.form.cuidados,
                'ids_tipo_aplicacao': this.form.idTipoAplicacaoSelecionado,
                'ids_local_aplicacao': this.form.idLocalAplicacaoSelecionado,
                'codigo_produto': this.form.productCode,
                'codigo_rnds': this.form.codeRndsVaccine,
                'codigo_smd_integracao': this.form.codeExternalIntegration,
                'ids_doencas' : this.$helpers.retornaAtributoArray(this.doencasSelecionadas, 'id_doenca'),
                tipo_aplicacao_dose: this.form.dose.type,
                intervalo_entre_doses: parseInt(this.form.dose.interval) ?? null,
                periodo_intervalo_entre_doses: this.form.dose.interval ? this.form.dose.intervalDateOption.value : null,
                doses: this.form.dose.type == "Múltiplas Doses" ? this.formatDosesConfiguration(this.form.dose.list) : null,
                id_tipo_vacina: this.form.tipoVacina.id_tipo_vacina ?? null,
                codigo_formulario: this.form.codigoFormulario,
                codigo_projeto: this.form.codigoProjeto,
                codigo_serie: this.form.codigoSerie,
                centro_responsabilidade: this.form.centroResponsabilidade,
                codigo_modalidade: this.form.codigoModalidade,
                codigo_carga_horaria: this.form.codigoCargaHoraria,
                codigo_competencia: this.form.codigoCompetencia,
                codigo_financiamento: this.form.codigoFinanciamento,
                codigo_unidade_controle: this.form.codigoUnidadeControle,
            }

            this.$http.put(this.$api.vaccineParameter(this.idVacinaEditar), parameters, {
                config: {
                    charset: 'utf-8'
                }
            }).then((data) => {
                if(redirectToList) {
                    this.openModalSucesso();
                }

                this.saving = false;
                this.cleanForm();

            }).catch(({ response: { data } }) => {
                handleErrorsService.handleErrosVacina(data, this.form.errorApi);

                this.saving = false;
            })
        },
        formatDosesConfiguration(doses) {
            const listDoses = [];

            doses.forEach((item) => {
                listDoses.push({
                id_dose: item.dose.id_dose,
                idade_recomendada_de: parseInt(item.numberSinceAgeRecomended) ?? null,
                idade_recomendada_ate: parseInt(item.numberUntilAgeRecomended) ?? null,
                idade_limite_de: parseInt(item.numberSinceAgeLimit) ?? null,
                idade_limite_ate: parseInt(item.numberUntilAgeLimit) ?? null,
                periodo_idade_recomendada_de: item.numberSinceAgeRecomended ? item.sinceAgeRecomended : null,
                periodo_idade_recomendada_ate: item.numberUntilAgeRecomended ? item.untilAgeRecomended : null,
                periodo_idade_limite_de: item.numberSinceAgeLimit ? item.sinceAgeLimit : null,
                periodo_idade_limite_ate: item.numberUntilAgeLimit ? item.untilAgeLimit : null,
                });
            });

            return listDoses.length > 0 ? listDoses : null;
        },
        cleanForm() {
            this.form.nomeTecnico = '';
            this.form.nomePopular = '';
            this.form.descricao = '';
            this.form.contraindicacao = '';
            this.form.efeitoColateral = '';
            this.form.productCode = '';
            this.form.codeRndsVaccine = '';
            this.form.codeExternalIntegration = '';
            this.form.cuidados = '';
            this.form.idTipoAplicacaoSelecionado = '';
            this.form.idLocalAplicacaoSelecionado = '';
            this.doencasSelecionadas = [];

            this.form.errorApi.nomeTecnico = '';
            this.form.errorApi.nomePopular = '';
            this.form.errorApi.descricao = '';
            this.form.errorApi.contraindicacao = '';
            this.form.errorApi.efeitoColateral = '';
            this.form.errorApi.cuidados = '';
            this.form.errorApi.idTipoAplicacaoSelecionado = '';
            this.form.errorApi.idLocalAplicacaoSelecionado = '';
            this.form.errorApi.doencasSelecionadas = '';
            this.form.errorApi.error = '';
            this.form.tipoVacina = null;
            this.form.codigoFormulario = '';
            this.form.codigoProjeto = '';
            this.form.codigoSerie = '';
            this.form.centroResponsabilidade = '';
            this.form.codigoModalidade = '';
            this.form.codigoCargaHoraria = '';
            this.form.codigoCompetencia = '';
            this.form.codigoFinanciamento = '';
            this.form.codigoUnidadeControle = '';

            this.$refs.vacinaRules.reset();
        },

        redirecionarLista() {
            this.$router.push({ name: 'vacina-list' });
        },

        doencaSelecionadaAjuste(doencasBruto) {
            const doencasSelecionadas = [];
            const doencasPreparacao = doencasBruto ?? [];
            for (const doenca of doencasPreparacao) {
                const objeto = {
                    id_doenca: doenca.pivot.id_doenca,
                    nome_tecnico: doenca.nome_tecnico,
                    ativo: doenca.ativo,
                };
                doencasSelecionadas.push(objeto);
            }
            return doencasSelecionadas;
        },

        async preenchimentoFormulario(dados){
            this.$http.get(this.$api.getTiposAplicacao(), {
                params: {
                    ativo: true,
                    colunaOrdenar: "codigo_via_administracao"
                }
            })
            .then(({ data }) => {
                this.form.idTipoAplicacaoSelecionado = dados.tipos_aplicacao.map(item => item.id_tipo_aplicacao);
                this.tiposAplicacaoSelect = data;
            });

            this.$http.get(this.$api.getLocaisAplicacao(), {
                params: {
                    ativo: true,
                    colunaOrdenar: "codigo_local_aplicacao"
                }
            })
            .then(({ data }) => {
                this.form.idLocalAplicacaoSelecionado = dados.locais_aplicacao.map(item => item.id_local_aplicacao);
                this.locaisAplicacaoSelect = data;
            });

            this.setDoseConfiguration(dados);

            await this.listaTiposVacina();

            this.idVacinaEditar = dados.id_vacina;
            this.form.nomeTecnico = dados.nome_tecnico;
            this.form.nomePopular = dados.nome_popular;
            this.form.descricao = dados.descricao;
            this.form.productCode = dados.codigo_produto;
            this.form.codeRndsVaccine = dados.codigo_rnds;
            this.form.codeExternalIntegration = dados.codigo_smd_integracao;
            this.form.contraindicacao = dados.contraindicacao;
            this.form.efeitoColateral =  dados.efeito_colateral;
            this.form.cuidados = dados.cuidados;
            this.tituloNome = dados.nome_tecnico;
            this.linkItems[1].name = 'Editar '+dados.nome_tecnico;
            this.doencasSelecionadas = this.doencaSelecionadaAjuste(dados.doencas);
            this.form.tipoVacina  = this.tipoVacinaOptions[dados.id_tipo_vacina - 1];
            this.form.codigoFormulario = dados.codigo_formulario;
            this.form.codigoProjeto = dados.codigo_projeto;
            this.form.codigoSerie = dados.codigo_serie;
            this.form.centroResponsabilidade = dados.centro_responsabilidade;
            this.form.codigoModalidade = dados.codigo_modalidade;
            this.form.codigoCargaHoraria = dados.codigo_carga_horaria;
            this.form.codigoCompetencia = dados.codigo_competencia;
            this.form.codigoFinanciamento = dados.codigo_financiamento;
            this.form.codigoUnidadeControle = dados.codigo_unidade_controle;
            this.form.existeRegistroVacinacao = dados.existe_registros_vacinacao;
        },
        setDoseConfiguration(dados){
            this.form.dose.type = dados.tipo_aplicacao_dose;
            this.form.dose.interval = this.prepareNumber(dados.intervalo_entre_doses);
            this.form.dose.intervalDateOption.value = dados.periodo_intervalo_entre_doses ?? 'dias';
            this.form.dose.list = dados.doses.map(item => {
                return {
                    dose: {
                        id_dose: item.dose.id_dose,
                        descricao: item.dose.descricao,
                        dosagem: item.dose.dosagem,
                        ativo: item.dose.ativo,
                        br_dose: item.dose.br_dose,
                    },
                    numberSinceAgeRecomended: this.prepareNumber(item.idade_recomendada_de),
                    numberUntilAgeRecomended: this.prepareNumber(item.idade_recomendada_ate),
                    numberSinceAgeLimit: this.prepareNumber(item.idade_limite_de),
                    numberUntilAgeLimit: this.prepareNumber(item.idade_limite_ate),
                    sinceAgeRecomended: item.periodo_idade_recomendada_de ?? 'dias',
                    untilAgeRecomended: item.periodo_idade_recomendada_ate ?? 'dias',
                    sinceAgeLimit: item.periodo_idade_limite_de ?? 'dias',
                    untilAgeLimit: item.periodo_idade_limite_ate ?? 'dias'
                }
            })
        },
        prepareNumber(num){
            if(num === 0){
                return "0";
            }
            return num;
        },

        openModalConfirm() {
            this.modal.showModal = true;
        },

        closeModalConfirm() {
            this.modal.showModal = false;
        },

        closeModalConfirmacaoAlteracao() {
          this.modalConfirmacaoAlteracao.showModal = false;
          this.saving = false;
        },

        openModalSucesso() {
            this.modalSucesso.showModal = true;
        },

        openModalError() {
            this.modalError.showModal = true;
        },

        setDoenca(doencaIds) {
            this.doencasSelecionadas = doencaIds;
        },

        async listaTiposVacina() {
          await this.$http.get(this.$api.tiposDeVacina()).then(response => {
            response.data.forEach(tipoVacina => {
              this.tipoVacinaOptions.push(tipoVacina);
            });
          });
        },
    }
}
</script>

<style>
.label_size_vacina{
    font-size: 15px;
    margin-top: -5px;
}
@media (max-width: 768px) {
    .buttons{
        text-align: center;
    }
    .botao_responsivo{
        margin-left: 1.25rem;
    }
}
</style>
